export default __webpack_public_path__ + "static/media/LogoFrameBlack.ef732785.svg";